export const sharedSourceNames = {
  background: 'assets_shared_popups_background_shadow.svg',
};

export const diceOneSources = [
  { name: 'assets_dices_dice1_1.png', path: 'assets/dices/1/dice1_1.png' },
  { name: 'assets_dices_dice1_2.png', path: 'assets/dices/1/dice1_2.png' },
  { name: 'assets_dices_dice1_3.png', path: 'assets/dices/1/dice1_3.png' },
  { name: 'assets_dices_dice1_4.png', path: 'assets/dices/1/dice1_4.png' },
  { name: 'assets_dices_dice1_5.png', path: 'assets/dices/1/dice1_5.png' },
];

export const diceTwoSources = [
  { name: 'assets_dices_dice2_1.png', path: 'assets/dices/2/dice2_1.png' },
  { name: 'assets_dices_dice2_2.png', path: 'assets/dices/2/dice2_2.png' },
  { name: 'assets_dices_dice2_3.png', path: 'assets/dices/2/dice2_3.png' },
  { name: 'assets_dices_dice2_4.png', path: 'assets/dices/2/dice2_4.png' },
  { name: 'assets_dices_dice2_5.png', path: 'assets/dices/2/dice2_5.png' },
];

export const diceThreeSources = [
  { name: 'assets_dices_dice3_1.png', path: 'assets/dices/3/dice3_1.png' },
  { name: 'assets_dices_dice3_2.png', path: 'assets/dices/3/dice3_2.png' },
  { name: 'assets_dices_dice3_3.png', path: 'assets/dices/3/dice3_3.png' },
  { name: 'assets_dices_dice3_4.png', path: 'assets/dices/3/dice3_4.png' },
  { name: 'assets_dices_dice3_5.png', path: 'assets/dices/3/dice3_5.png' },
];

export const diceFourSources = [
  { name: 'assets_dices_dice4_1.png', path: 'assets/dices/4/dice4_1.png' },
  { name: 'assets_dices_dice4_2.png', path: 'assets/dices/4/dice4_2.png' },
  { name: 'assets_dices_dice4_3.png', path: 'assets/dices/4/dice4_3.png' },
  { name: 'assets_dices_dice4_4.png', path: 'assets/dices/4/dice4_4.png' },
  { name: 'assets_dices_dice4_5.png', path: 'assets/dices/4/dice4_5.png' },
];

export const diceFiveSources = [
  { name: 'assets_dices_dice5_1.png', path: 'assets/dices/5/dice5_1.png' },
  { name: 'assets_dices_dice5_2.png', path: 'assets/dices/5/dice5_2.png' },
  { name: 'assets_dices_dice5_3.png', path: 'assets/dices/5/dice5_3.png' },
  { name: 'assets_dices_dice5_4.png', path: 'assets/dices/5/dice5_4.png' },
  { name: 'assets_dices_dice5_5.png', path: 'assets/dices/5/dice5_5.png' },
];

export const diceSixSources = [
  { name: 'assets_dices_dice6_1.png', path: 'assets/dices/6/dice6_1.png' },
  { name: 'assets_dices_dice6_2.png', path: 'assets/dices/6/dice6_2.png' },
  { name: 'assets_dices_dice6_3.png', path: 'assets/dices/6/dice6_3.png' },
  { name: 'assets_dices_dice6_4.png', path: 'assets/dices/6/dice6_4.png' },
  { name: 'assets_dices_dice6_5.png', path: 'assets/dices/6/dice6_5.png' },
];

export const MagicDiceLayers = {
  background: 'background',
  chest: 'chest',
  dancerGirl: 'dancerGirl',
  winNumber: 'winNumber',
  dices: 'dices',
};

export const magicDiceAnimationNames = {
  background: 'background',
  chest: 'chest',
  dancerGirl: 'dancerGirl',
  winNumber: 'winNumber',
  dices: 'dices',
};

export const magicDiceWebAnimationSources = [
  {
    name: magicDiceAnimationNames.background,
    path: 'assets/web/background.jpg',
  },
  {
    name: magicDiceAnimationNames.chest,
    path: 'animations/web/chest/chest-1.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/chest/chest-1.atlas',
      },
    },
  },
  {
    name: magicDiceAnimationNames.dancerGirl,
    path: 'animations/web/dancer/dancer.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/dancer/dancer.atlas',
      },
    },
  },
  ...diceOneSources,
  ...diceTwoSources,
  ...diceThreeSources,
  ...diceFourSources,
  ...diceFiveSources,
  ...diceSixSources,
];

export const magicDiceMobileAnimationSources = [
  {
    name: magicDiceAnimationNames.background,
    path: 'assets/mobile/background.png',
  },
  {
    name: magicDiceAnimationNames.chest,
    path: 'animations/mobile/chest/chest-1_mobile.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/chest/chest-1_mobile.atlas',
      },
    },
  },
  {
    name: magicDiceAnimationNames.dancerGirl,
    path: 'animations/mobile/dancer/dancer.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/dancer/dancer.atlas',
      },
    },
  },
  ...diceOneSources,
  ...diceTwoSources,
  ...diceThreeSources,
  ...diceFourSources,
  ...diceFiveSources,
  ...diceSixSources,
];

export const diceSourceNames = [
  [
    'assets_dices_dice1_1.png',
    'assets_dices_dice1_2.png',
    'assets_dices_dice1_3.png',
    'assets_dices_dice1_4.png',
    'assets_dices_dice1_5.png',
  ],
  [
    'assets_dices_dice2_1.png',
    'assets_dices_dice2_2.png',
    'assets_dices_dice2_3.png',
    'assets_dices_dice2_4.png',
    'assets_dices_dice2_5.png',
  ],
  [
    'assets_dices_dice3_1.png',
    'assets_dices_dice3_2.png',
    'assets_dices_dice3_3.png',
    'assets_dices_dice3_4.png',
    'assets_dices_dice3_5.png',
  ],
  [
    'assets_dices_dice4_1.png',
    'assets_dices_dice4_3.png',
    'assets_dices_dice4_3.png',
    'assets_dices_dice4_4.png',
    'assets_dices_dice4_5.png',
  ],
  [
    'assets_dices_dice5_1.png',
    'assets_dices_dice5_2.png',
    'assets_dices_dice5_3.png',
    'assets_dices_dice5_4.png',
    'assets_dices_dice5_5.png',
  ],
  [
    'assets_dices_dice6_1.png',
    'assets_dices_dice6_2.png',
    'assets_dices_dice6_3.png',
    'assets_dices_dice6_4.png',
    'assets_dices_dice6_5.png',
  ],
];
